import React, { useEffect, useState } from "react";
import { toast } from "./ui/sonner";
import { useApp } from "../context/AppContext";
import { Loader2, RotateCcw, CheckCircle2, Trash2 } from "lucide-react";

/* 铃铛内联「恢复」：recycle_expiring 提醒（客户 / 工程项目回收站即将到期）一键恢复 */
export const RecycleRestoreInline = ({ reminder, compact = false, onChanged }) => {
  const { api, lang } = useApp();
  const zh = lang === "zh";
  const kind = reminder.recycleKind;
  const iid = reminder.recycleId;
  const [st, setSt] = useState(null);
  const [busy, setBusy] = useState(false);
  const [denied, setDenied] = useState(false);
  useEffect(() => { if (kind && iid) api.get(`/recycle-bin/item/${kind}/${iid}`).then((r) => setSt(r.data)).catch(() => setDenied(true)); }, [api, kind, iid]);
  if (!kind || !iid || denied) return null;
  if (!st) return <p className="text-[10px] text-slate-400"><Loader2 className="h-3 w-3 animate-spin inline" /></p>;
  const restore = async (e) => {
    e.stopPropagation();
    setBusy(true);
    try {
      await api.post(kind === "lead" ? `/leads/${iid}/restore` : `/projects/${iid}/restore`);
      setSt({ ...st, inBin: false, restored: true });
      toast.success(zh ? `已恢复：${st.label}` : `Restored: ${st.label}`);
      onChanged?.();
    } catch (err) { toast.error(err?.response?.data?.detail || (zh ? "恢复失败" : "Restore failed")); } finally { setBusy(false); }
  };
  return (
    <div className={`flex items-center gap-2 ${compact ? "text-[10px]" : "text-[11px]"}`} data-testid={`recycle-inline-${reminder.id}`} data-state={st.inBin ? "in_bin" : st.restored ? "restored" : "purged"}>
      <span className="text-slate-500 inline-flex items-center gap-1 min-w-0 truncate"><Trash2 className="h-3 w-3 shrink-0" />{st.label}</span>
      {st.inBin ? (
        <button type="button" data-testid={`recycle-inline-restore-${reminder.id}`} disabled={busy} onClick={restore}
          className="ml-auto inline-flex items-center gap-1 rounded-full bg-emerald-600 hover:bg-emerald-700 text-white font-semibold px-2.5 py-1 disabled:opacity-50">
          {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <RotateCcw className="h-3 w-3" />}{zh ? `恢复（剩 ${st.daysLeft ?? 0} 天）` : `Restore (${st.daysLeft ?? 0}d left)`}
        </button>
      ) : st.restored ? (
        <span className="ml-auto inline-flex items-center gap-1 text-emerald-600 font-semibold" data-testid={`recycle-inline-status-${reminder.id}`}><CheckCircle2 className="h-3 w-3" />{zh ? "已恢复" : "Restored"}</span>
      ) : (
        <span className="ml-auto text-slate-400" data-testid={`recycle-inline-status-${reminder.id}`}>{zh ? "已彻底删除" : "Permanently deleted"}</span>
      )}
    </div>
  );
};
